import React from 'react';
import styles from './PartnerLogos.module.scss';

const DigitalJournalLogo = () => (
  <div className={styles.logoText}>
    <span className={styles.logoIcon}>■</span>
    <span>DIGITAL JOURNAL</span>
  </div>
);

const USATodayLogo = () => (
  <div className={styles.logoText}>
    <span className={styles.usaCircle}>●</span>
    <span className={styles.usaText}>USA<br/>TODAY</span>
  </div>
);

const MindvalleyLogo = () => (
  <div className={styles.logoText}>
    <span>Mindvalley</span>
    <span className={styles.checkmark}>✓</span>
  </div>
);

const AppSumoLogo = () => (
  <div className={styles.logoText}>
    <span className={styles.appsumo}>APPSUMO</span>
  </div>
);

const AdobeSummitLogo = () => (
  <div className={styles.logoText}>
    <span><span className={styles.adobeA}>A</span>dobe Summit</span>
  </div>
);

const VentureCapitalLogo = () => (
  <div className={styles.logoText}>
    <span className={styles.ventureText}>VENTURE CAPITAL POST</span>
  </div>
);

const PartnerLogos = () => {
  return (
    <div className={styles.logos}>
      <DigitalJournalLogo />
      <USATodayLogo />
      <MindvalleyLogo />
      <AppSumoLogo />
      <AdobeSummitLogo />
      <VentureCapitalLogo />
    </div>
  );
};

export default PartnerLogos;
